
















































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CartItemViewModel from "@/chipply/view-model/CartItemViewModel";
import chipplyIcons from "@/chipply/ImportIcons";
import CartItemAttributeViewModel from "@/chipply/view-model/CartItemAttributeViewModel";
import Validation from "@/chipply/Validation";

@Component({})
export default class CartItemInfo extends Vue {
    public name = "CartItemInfo";

    public chipplyIcons = chipplyIcons;
    public originalValue = "";

    @Prop({ type: Object })
    public vm!: CartItemViewModel;

    @Prop({ type: Boolean, default: false })
    public isRequestor!: boolean;

    public get smallScreen() {
        return !this.$vuetify.breakpoint.smAndUp;
    }

    public get design() {
        return this.vm.designs.filter((x) => x.value == this.vm.eventProductId && x.display !== "Blank Item");
    }

    private async setOriginalValue(value: string) {
        this.originalValue = value;
    }

    private async markAttrChange(option: CartItemAttributeViewModel) {
        option.valueChanged = true;
    }

    protected validateOptionField(option: CartItemAttributeViewModel) {
        if (!option.isRequired || (option.userValue && option.userValue != "")) {
            return true;
        }
        return "Product Option required";
    }

    protected validateMaxLength(option: CartItemAttributeViewModel) {
        if (option.maxLength === 0) {
            return true;
        } else {
            return Validation.requireMaximumLengthOf(option.maxLength)(option.userValue);
        }
    }
}
